import { ExperienceCard, type ExperienceCardEntity } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const exp: ExperienceCardEntity = {
  id: "1",
  title: "Intro to Calculus",
  type: "quest",
  description:
    "A short, friendly course covering limits, derivatives, and integrals with worked examples and quick checks.",
  creatorName: "Ada Lovelace",
  studioName: "Math Studio",
  tags: ["math", "beginner"],
  likeCount: 42,
};

export function ExperienceCardDensityDemo() {
  return (
    <Section
      id="experience-card-density"
      title="ExperienceCard density"
      description="ExperienceCard wears the Onyx hex-notch surface — it composes the brand Card, so it inherits the nx-s silhouette, the clip-safe .elev-card drop-shadow, and the continuous nx-rim keyline ring (no second keyline here). The .Skeleton renders its own placeholder surface, so it adopts the same recipe directly. Below: the density axis — comfortable (default) keeps the action footer; editorial drops it (whole-card click), enlarges the title, and gives the description three lines."
    >
      <VariantBlock label="Comfortable" caption="default — notch surface (inherited from Card) + action footer with the Open CTA + dropdown">
        <div className="w-[340px]">
          <ExperienceCard experience={exp} mode="explore" onView={() => {}} />
        </div>
      </VariantBlock>

      <VariantBlock label="Editorial" caption='density="editorial" — larger title, 3-line description, no footer (whole-card click)'>
        <div className="w-[340px]">
          <ExperienceCard experience={exp} mode="explore" density="editorial" onView={() => {}} />
        </div>
      </VariantBlock>

      <VariantBlock label="List" caption='view="list" — horizontal row, same inherited notch surface + nx-rim keyline'>
        <div className="w-[520px] max-w-full">
          <ExperienceCard experience={exp} mode="explore" view="list" onView={() => {}} />
        </div>
      </VariantBlock>

      <VariantBlock label="Skeleton (comfortable)" caption="ExperienceCard.Skeleton — placeholder surface adopts the notch recipe directly: nx-s + .elev-card drop-shadow + nx-rim ring (no border / box-shadow)">
        <div className="w-[340px]">
          <ExperienceCard.Skeleton />
        </div>
      </VariantBlock>

      <VariantBlock label="Skeleton (editorial)" caption="ExperienceCard.Skeleton matches the editorial footprint while loading">
        <div className="w-[340px]">
          <ExperienceCard.Skeleton density="editorial" />
        </div>
      </VariantBlock>
    </Section>
  );
}
